import { render } from "./TelegramTemplatesPanel.vue?vue&type=template&id=20b3ba50&scoped=true"
import script from "./TelegramTemplatesPanel.vue?vue&type=script&lang=js"
export * from "./TelegramTemplatesPanel.vue?vue&type=script&lang=js"

import "./TelegramTemplatesPanel.vue?vue&type=style&index=0&id=20b3ba50&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b3ba50"]])

export default __exports__